import { render, staticRenderFns } from "./RegionOverview.vue?vue&type=template&id=acf35234&"
import script from "./RegionOverview.vue?vue&type=script&lang=js&"
export * from "./RegionOverview.vue?vue&type=script&lang=js&"
import style0 from "./RegionOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports